var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.parameterSearch
      ? _c("div", { staticClass: "row q-col-gutter-md q-pb-lg" }, [
          _c(
            "div",
            { staticClass: "col" },
            [
              _c("q-btn", {
                attrs: {
                  label: _vm.$t("button.createWatchlist"),
                  icon: "create",
                  color: "primary",
                  "no-caps": ""
                },
                on: { click: _vm.createWatchlist }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("q-table", {
            attrs: {
              title: _vm.$t("watchlists"),
              data: _vm.watchlists,
              columns: _vm.columns,
              pagination: _vm.pagination,
              loading: _vm.isLoading,
              filter: _vm.filter,
              "row-key": "uid"
            },
            on: {
              "update:pagination": function($event) {
                _vm.pagination = $event
              },
              request: _vm.onRequest
            },
            scopedSlots: _vm._u([
              {
                key: "top-right",
                fn: function() {
                  return [
                    _c("q-input", {
                      attrs: {
                        borderless: "",
                        dense: "",
                        debounce: "300",
                        placeholder: _vm.$t("label.search")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "append",
                          fn: function() {
                            return [_c("q-icon", { attrs: { name: "search" } })]
                          },
                          proxy: true
                        }
                      ]),
                      model: {
                        value: _vm.filter,
                        callback: function($$v) {
                          _vm.filter = $$v
                        },
                        expression: "filter"
                      }
                    })
                  ]
                },
                proxy: true
              },
              {
                key: "body-cell-name",
                fn: function(cell) {
                  return [
                    _c(
                      "q-td",
                      [
                        !_vm.emit
                          ? [
                              _c("watchlist-link", {
                                attrs: { watchlist: cell.row }
                              })
                            ]
                          : [
                              _c("watchlist-teaser", {
                                attrs: { watchlist: cell.row },
                                nativeOn: {
                                  click: function($event) {
                                    return _vm.$emit(
                                      "select-watchlist",
                                      cell.row
                                    )
                                  }
                                }
                              })
                            ]
                      ],
                      2
                    )
                  ]
                }
              },
              {
                key: "body-cell-actions",
                fn: function(cell) {
                  return [
                    !_vm.parameterSearch
                      ? _c(
                          "q-btn",
                          {
                            attrs: {
                              color: "primary",
                              icon: "more_vert",
                              outline: "",
                              dense: ""
                            }
                          },
                          [
                            _c(
                              "q-menu",
                              [
                                _c(
                                  "q-list",
                                  [
                                    _c(
                                      "q-item",
                                      {
                                        directives: [
                                          {
                                            name: "close-popup",
                                            rawName: "v-close-popup"
                                          }
                                        ],
                                        attrs: { clickable: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.editWatchlist(cell.row)
                                          }
                                        }
                                      },
                                      [
                                        _c("q-item-section", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("button.watchlistSettings")
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "q-item",
                                      {
                                        directives: [
                                          {
                                            name: "close-popup",
                                            rawName: "v-close-popup"
                                          }
                                        ],
                                        attrs: { clickable: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.share(cell.row)
                                          }
                                        }
                                      },
                                      [
                                        _c("q-item-section", [
                                          _vm._v(_vm._s(_vm.$t("button.share")))
                                        ])
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !cell.row.searchParams
                                      ? _c(
                                          "q-item",
                                          {
                                            directives: [
                                              {
                                                name: "close-popup",
                                                rawName: "v-close-popup"
                                              }
                                            ],
                                            attrs: { clickable: "" },
                                            on: {
                                              click: function($event) {
                                                return _vm.downloadWatchlistSummary(
                                                  cell.row
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _c("q-item-section", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "button.downloadWatchlistSummary"
                                                  )
                                                )
                                              )
                                            ])
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "q-item",
                                      {
                                        directives: [
                                          {
                                            name: "close-popup",
                                            rawName: "v-close-popup"
                                          }
                                        ],
                                        attrs: { clickable: "" },
                                        on: {
                                          click: function($event) {
                                            return _vm.deleteWatchlist(cell.row)
                                          }
                                        }
                                      },
                                      [
                                        _c("q-item-section", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t("button.deleteWatchlist")
                                            )
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }